<template>
	<div class="footer">
		<div class="Fcenter">
			<div class="about">
				<h1 class="aboutYi">关于以诺</h1>
        <ul class="zhAbout">
          <li><router-link to="/AboutEnoch">以诺源起</router-link></li>
          <li><router-link to="/AboutEnoch">校长寄语</router-link></li>
        </ul>
        <ul class="send zhAbout">
          <li><router-link to="/AboutEnoch">愿景与使命</router-link></li>
          <li><router-link to="/AboutEnoch">我们的服务</router-link></li>
        </ul>
			</div>
			<div class="contactOur">
				<h1 class="aboutYi">联系我们</h1>
				<p class="dizhi"><Icon type="ios-location" class="juli"></Icon>上海市闵行区申滨南路1226号诺亚财富中心</p>
				<p><Icon type="ios-email" class="juli"></Icon>enoch.service@noahwm.com</p>
			</div>
			<div class="contactPh">
				<p class="phonenumber">400-820-0025-3</p>
				<p class="timershow">周一至周五9:00-18:00</p>
			</div>
			<div class="QR">
				<img src="../../assets/QR.jpg" class="footQR"/>
				<p>扫一扫，关注我们</p>
			</div>
			<div class="clears"></div>
			<p class="foot">Copyright © 2017 -  {{ new Date().getFullYear()}} 以诺教育科技（上海）有限公司 版权所有；
				<img style="display:inline;width:20px;height:22px;margin-left:10px;margin-right:2px;vertical-align:middle;position:relative;top:-2px;" src="../../assets/police.png">
				<a href="https://beian.mps.gov.cn/#/query/webSearch?code=31011202022626" rel="noreferrer" target="_blank">沪公网安备31011202022626号；</a>
				<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" rel="noreferrer" target="_blank">沪ICP备15049725号-1；</a>
				<img src="../../assets/wangjing.jpg" class="wangjing" title="亲爱的市民朋友，上海警方反诈劝阻电话“962110”系专门针对避免您财产被骗受损而设，请您一旦收到来电，立即接听">
		    </p>
		</div>
	</div>
</template>
<script>
	export default{
		name:"Bottom",
    mounted(){
      $(".zhAbout li").click(function(){
        $(document).scrollTop(0)
      })
    },
	}
</script>

<style scoped>
	.footer{width:100%;height:235px;background:#303030;margin-top: -235px;}
	.Fcenter{width:1160px;height:160px;margin:0 auto;border-bottom:1px solid #505050;}
	.about{width:172px;height:100%;float: left;}
	.aboutYi{color:#fff;font-size: 18px;padding-top:42px;}
	.juli{margin-right:12px;}
	.about ul{color:#aaa;float: left;margin-top:20px;}
	.send{margin-left:45px;}
	.about ul li{margin-bottom:10px;}
	.contactOur{float: left;margin:0 0 0 145px;}
	.contactOur p{color:#aaa;}
	.dizhi{margin:14px 0 10px 0;}
	.contactPh{width:245px;float:left;margin-left:165px;}
	.phonenumber{font-size: 30px;color:#fff;margin-top:42px;text-align:right;}
	.timershow{color:#aaa;margin:10px 0 0 0;text-align:right;}
	.QR{width:118px;float:right;}
	.QR p{color:#aaa;}
	.footQR{width:100px;height:100px;margin:20px 0 0 6px;}
	.foot{color:#aaa;margin-top:24px;position: relative;}
	.foot a{color: rgb(116, 154, 227);}
	.clears{clear: both;}
  .zhAbout>li>a{color:#aaaaaa;}
	.wangjing {width: 100px;height: 60px;position: absolute;right: 12px;top:-15px;}
</style>



// WEBPACK FOOTER //
// Bottom.vue?67af2669